/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserSortCriteria {
    getFixupPrototypeFunction() { return UserSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<UserSortCriteria>): UserSortCriteria {
        let obj = Object.assign(new UserSortCriteria(), model);
        UserSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserSortCriteria>): UserSortCriteria {
        if (!model) return null;
        return UserSortCriteria.newInstance(<UserSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserSortCriteria) {
        if (!obj) return;

        models.UserSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserSortCriteria): boolean {
        Object.setPrototypeOf(obj, UserSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.UserSortColumn;

    ascending: boolean;

}
